import { mapGetters, mapMutations } from 'vuex';

import { changeDay } from '@/main';
import api from '@/api';

let globalExperience = [];

// Meses hacia delante que se buscan como máximo cuando el mes cargado no tiene días disponibles
const MAX_MONTHS_SEARCH = 12;

export default {
    extends: api,
    props: ['numberPlayers', 'experience', 'type', 'experiences'],
    data() {
        return {
            gaps: 0,
            notFound: false,
            currentMonth: 0,
            currentDay: 0,
            lastDay: 31,
            currentYear: 0,
            days: []
        }
    },
    computed: {
        ...mapGetters(['getDisplayMode', 'canShowStepTwo', 'getBlockView', 'getDateSelected', 'getCheckout']),
        showArrowLeft: function () {
            let date = new Date();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();

            return !(this.currentMonth === month && this.currentYear === year);
        },
        monthName: function () {
            // Obtener el idioma de la URL
            const urlLocale = window.location.pathname.split('/').pop();

            // Función para determinar el locale basado en urlLocale
            function getLocale() {
                switch (true) {
                    case urlLocale.startsWith('ca'):
                        return 'ca-ES';
                    case urlLocale.startsWith('en'):
                        return 'en-EN';
                    case urlLocale.startsWith('gl'):
                        return 'gl';
                    case urlLocale.startsWith('fr'):
                        return 'fr';
                    default:
                        return 'es-ES';
                }
            }

            // Mapeo manual de los nombres de los meses en gallego
            const monthNamesGalician = ['xan', 'feb', 'mar', 'abr', 'mai', 'xuñ', 'xul', 'ago', 'set', 'out', 'nov', 'dec'];

            const date = new Date(this.currentYear, this.currentMonth - 1, 1);
            const locale = getLocale();

            if (locale === 'gl') {
                return monthNamesGalician[this.currentMonth - 1];
            } else {
                return date.toLocaleString(locale, { month: 'short' });
            }
        },
        dayObject: function () {
            return (dayNumber, enabled) => {
                const day = this.days.find(d => d.number === dayNumber);
                const isBlockedView = this.getBlockView() === 'block';


                if (this.type === 'minimal') {
                    if (this.getDateSelected() === day?.formattedDate) {
                        /*
                        Solo en minimal
                        Si la fecha seleccionada es 
                        es igual al día que viene iterando
                        se debe de poner ese día como marcado
                        */
                        return { "current": true, "current-enabled": true, "enabled": true }
                    } else if (day && !this.hasAvaibilityForToday(day?.formattedDate, this.getDateSelected())) {
                        /*
                        Si es hoy y no tiene sesiones disponibles debe de bloquear el día
                        */
                        return {
                            'block': this.checkDateBefore(dayNumber) && day.blocked >= day.total && isBlockedView
                        }
                    }
                }


                if (day && enabled) {
                    const checkLow = (day.occupied / day.total) * 100 > 20;
                    const isCurrentDay = this.currentDay === dayNumber;
                    const block = day.occupied >= day.total || isCurrentDay;
                    const isEnabled = day.occupied < day.total && day.total > 0;


                    if (this.isBlockedTodayByHours(day.date, this.experiences)) {
                        return {
                            'block': this.checkDateBefore(dayNumber) && day.occupied >= day.total && isBlockedView
                        }
                    }

                    return {
                        'current': isCurrentDay,
                        'current-enabled': isCurrentDay && isEnabled && !checkLow,
                        'current-low': isCurrentDay && isEnabled && checkLow,
                        'enabled': isEnabled,
                        'low': checkLow,
                        'block': block
                    }
                } else {
                    /*
                    Al marcar en la integración Visualización de días enteros bloqueados mostrar a como completo se pone el tipo  
                    blockview": "block"
                    Si se marca: ver como cerrado se pone el tipo closed
                    */
                    return {
                        'block': this.checkDateBefore(dayNumber) && day.occupied >= day.total && isBlockedView
                    }
                }
            };
        },
        checkDateBefore: function () {
            return (dayInCalendar) => {
                const day = this.days.find(d => d.date.getDate() === dayInCalendar);
                const date = new Date();
                date.setHours(0, 0, 0, 0);
                return !!day && day.date.getTime() >= date.getTime() && day.total > 0;
            }
        },
        checkDayBlockedView: function () {
            return (dayNumber) => {
                const day = this.days.find(d => d.number === dayNumber);
                return !!day && !(day.blocked >= day.total || day.occupied >= day.total);
            }
        },
        isEnabled: function () {
            return (day) => this.checkDateBefore(day) && this.checkDayBlockedView(day);
        },
        selectedDateComputed() {
            // Se usa una computada del estado para forzar hacer trigger cuando la fecha seleccionada cambie
            return this.getDateSelected()
        }
    },
    watch: {
        selectedDateComputed(newValue, oldValue) {
            // Cuando cambie la fecha se debe de forzar a recalcular el calendario
            // this.getCalendar();
            const [day, month, year] = this.getDateSelected().split('/').map(Number);

            /*
            Comparamos si el mes actual es le mismo que la fecha que cambia en el estado
            si no es la misma se tiene que cambiar el mes actual
            */
            if (this.currentMonth < month) {
                this.nextMonth();
            }
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        ...mapMutations(['updateCalendarDays']),
        async loadData() {
            let experiencesPromise = new Promise((resolve) => { this.getExperiencesByIdApi(resolve) });

            experiencesPromise.then((experiences) => {
                this.experiences = experiences;
                globalExperience = experiences;
                this.getCalendar();
                changeDay.$on('day-before', () => {
                    this.dayBefore();
                });
                changeDay.$on('day-after', () => {
                    this.dayAfter();
                })
            })

        },
        /*
        Esta es la finción que debe de usar pero
        de momento se usa la estrategia de saltar los días 
        mientras backend arregla los días especiales.
       
        dayBefore: function () {
            if (this.currentDay === 1) {
                const lastDay = new Date(this.currentYear, this.currentMonth - 1, 0);
                this.currentDay = lastDay.getDate();
                this.currentMonth--;
                this.getCalendar();
            }
            else {
                this.currentDay--;
                this.getCalendar(false, true);
            }
        },
         */
        dayBefore: function () {
            const currentDate = this.getDateSelected(); // Formato: 'DD/MM/YYYY'

            // Buscar el índice del día actual en this.days
            const currentIndex = this.days.findIndex(day => day.formattedDate === currentDate);

            if (currentIndex === -1) {
                this.currentDay--
            }

            // Buscar el día anterior disponible
            const prevAvailable = [...this.days.slice(0, currentIndex)].reverse().find(day => {
                if (this.getBlockView() === 'closed') {
                    return day.occupied < day.total;
                }
                return day.total > 0;
            });

            if (prevAvailable) {
                this.currentDay = prevAvailable.number;
                this.getCalendar(false, true);
            } else {
                // Si no hay más días disponibles en este mes, pasar al mes anterior
                this.previusMonth();
            }
        },
        /*
        Esta es la finción que debe de usar pero
        de momento se usa la estrategia de saltar los días 
        mientras backend arregla los días especiales.
     
        dayAfter: function () {
            const lastDay = new Date(this.currentYear, this.currentMonth - 1, 0);
            if (this.currentDay === lastDay.getDate()) {
                this.nextMonth()
            }
            else {
                this.currentDay++;
                this.getCalendar(false, true);
            }
        },
        */
        dayAfter: function () {
            const currentDate = this.getDateSelected(); // Formato: 'DD/MM/YYYY'

            // Buscar el índice del día actual en this.days
            const currentIndex = this.days.findIndex(day => day.formattedDate === currentDate);

            if (currentIndex === -1) {
                // si no encuentra pasa al siguente mes porque es ultimo día
                return this.nextMonth();
            };

            // Buscar el siguiente día disponible
            const nextAvailable = this.days.slice(currentIndex + 1).find(day => {
                if (this.getBlockView() === 'closed') {
                    return day.occupied < day.total
                }
                return day.total > 0;
            });

            if (nextAvailable) {
                this.currentDay = nextAvailable.number;
                this.getCalendar(false, true);
            } else {
                // Si no hay más días disponibles en este mes, pasar al siguiente mes
                this.nextMonth();
            }
        },
        nextMonth: function () {
            if (this.currentMonth === 12) {
                this.currentMonth = 1;
                this.currentYear++;
            }
            else this.currentMonth++;

            this.currentDay = 1;
            this.getCalendar(true);
        },
        previusMonth: function () {
            if (this.currentMonth === 1) {
                this.currentMonth = 12;
                this.currentYear--;
            }
            else this.currentMonth--;

            this.currentDay = 1;
            this.getCalendar(true);
        },
        getCalendar: function (month, isNextDay) {
            const date = new Date();
            const currentDate = new URLSearchParams(window.location.search).get('dateSelected');
            if (currentDate) {
                const currentDateArray = currentDate.split('/');
                this.currentMonth = currentDateArray[1];
                this.currentDay = currentDateArray[0];
                this.currentYear = currentDateArray[2];
            } else if (this.currentMonth === 0) {
                this.currentMonth = date.getMonth() + 1;
                this.currentDay = date.getDate();
                this.currentYear = date.getFullYear();
            }

            let firstDay = new Date(this.currentYear, this.currentMonth - 1, 1);
            let lastDay = new Date(this.currentYear, this.currentMonth, 0);

            this.gaps = firstDay.getDay() - 1;

            if (this.gaps === -1) this.gaps = 6;

            this.lastDay = lastDay.getDate();

            const firstDayFormated = firstDay.getDate() + '/' + this.currentMonth + '/' + this.currentYear;
            const lastDayFormated = lastDay.getDate() + '/' + this.currentMonth + '/' + this.currentYear;

            this.callGetCalendarIds(firstDayFormated, lastDayFormated, isNextDay);
        },
        callGetCalendarIds: function (fromDate, toDate, isNextDay, monthsSearched = 0) {
            const datePrommise = new Promise((resolve) => {
                if (this.type === 'minimal') {
                    /*
                    En calendarios minimal cada experiencia tiene su propio calendario que se muestra al seleccionar la experiencia
                    Por eso solo se pasa el id de esa experiencia porque este endpoint suma la disponibilidad de los mismos días si se pasa más de un id
                    */
                    this.getDatesApi(fromDate, toDate, resolve, [this.experience.id]);
                } else {
                    this.getDatesApi(fromDate, toDate, resolve);
                }
            });
            datePrommise.then((dates) => {
                this.updateCalendarDays({ days: dates });

                this.days = Object.keys(dates).map(key => {
                    const splittedDate = key.split('/');
                    return {
                        ...dates[key],
                        date: new Date(splittedDate[2], splittedDate[1] - 1, splittedDate[0]),
                        formattedDate: key,
                        number: Number(splittedDate[0])
                    }
                });

                let currentDate = this.days.find(day => this.isEnabled(day.number));


                if (!currentDate) {
                    /*
                    Si no existe currentDate significa que no tenemos disposnibilidad cargada para esos días
                    por lo tanto intentamos volver a cargarlos pero avanzando un día

                    La búsqueda se corta a los MAX_MONTHS_SEARCH meses: una experiencia sin
                    disponibilidad (o sin calendario) hacía peticiones mes a mes sin fin.
                    */
                    if (monthsSearched >= MAX_MONTHS_SEARCH) {
                        this.notFound = true;
                        return;
                    }

                    const [day, month, year] = this.getDateSelected().split('/').map(Number);

                    /*
                    Comparamos si el mes actual es le mismo que la fecha que cambia en el estado
                    si no es la misma se tiene que cambiar el mes actual.
                    nextMonth() ya lanza su propia búsqueda, así que no se encadena otra aquí:
                    hacerlo abría dos cadenas de peticiones en paralelo en cada salto.
                    */
                    if (this.currentMonth < month) {
                        return this.nextMonth();
                    }


                    const { firstDayNextMonth, lastDayNextMonth } = this.getNextMonthRange(fromDate);
                    return this.callGetCalendarIds(firstDayNextMonth, lastDayNextMonth, isNextDay, monthsSearched + 1);
                }

                if (isNextDay) {
                    const nextDay = this.days.find(d => d.number === this.currentDay);
                    if (currentDate && nextDay?.number >= currentDate?.number) {
                        currentDate = nextDay
                    }
                }

                if (this.type === 'minimal') {
                    this.currentDay = currentDate.number;
                    this.$emit('date-selected', currentDate.formattedDate);
                } else {
                    let experiencePrommise = new Promise((resolve) => { this.getExperiencesByIdApi(resolve) });

                    experiencePrommise.then((experiences) => {
                        this.experiences = experiences;

                        if (currentDate) {
                            if (this.hasCalendarPassedCurrentTime(this.experiences)) {
                                this.dayAfter();
                            } else {
                                this.currentDay = currentDate.number;
                                this.$emit('date-selected', currentDate.formattedDate);
                            }
                        }
                    })

                }
            });
        },
        selectDay: function (day) {
            const obj = this.dayObject(day, this.checkDateBefore(day) && this.checkDayBlockedView(day));
            if (obj.block || !obj.enabled) return;

            if (this.canShowStepTwo()) {
                const checkout = this.getCheckout();

                const shouldAnswer = checkout.id !== null || this.hasDataFullfilled();

                if (shouldAnswer) {
                    if (confirm(this.$t("cancelModal"))) {
                        this.$emit('cancel-purchase', { from: 'calendar' });
                    } else {
                        return;
                    }
                } else {
                    this.$emit('cancel-purchase', { from: 'calendar' });
                }
            }


            this.currentDay = day;
            let dateSelected = this.currentDay + '/' + this.currentMonth + '/' + this.currentYear;

            if (document.getElementById("step-one")) document.getElementById("step-one").scrollIntoView();

            this.$emit('date-selected-click', dateSelected)
        },
        toDate(fecha) {
            const [dia, mes, ano] = fecha.split('/').map(Number);
            return new Date(ano, mes - 1, dia);
        },
        hasAvaibilityForToday(iteratedDateStr, selectedDateStr) {
            const currentDate = new Date();
            const iteratedDate = this.toDate(iteratedDateStr);
            const selectedDate = this.toDate(selectedDateStr);

            // Comprobar si el día de la fecha iterada es hoy
            const isIteratedDateToday = iteratedDate.toDateString() === currentDate.toDateString();


            if (isIteratedDateToday) {
                const hours = this.experience.calendars.flatMap(cal => cal.schedules).map(schedule => schedule.start_session);

                // Crear un objeto Date para cada hora de hoy
                const availableTimesForToday = hours.map(hour => {
                    const [hourPart, minutePart] = hour.split(':');
                    const availableTime = new Date(currentDate);
                    availableTime.setHours(hourPart, minutePart, 0, 0);
                    return availableTime;
                });

                // Comprobar si hay sesiones disponibles para hoy
                const hasAvailableSessionsForToday = availableTimesForToday.some(availableTime => availableTime > currentDate);
                return hasAvailableSessionsForToday;
            } else {
                return true
            }



        },
        hasCalendarPassedCurrentTime(experiences) {
            const now = new Date();
            const isToday = now.getDate() === this.currentDay &&
                now.getMonth() + 1 === this.currentMonth &&
                now.getFullYear() === this.currentYear;

            // Si no es hoy, no evaluamos los horarios
            if (!isToday) {
                return false;
            }

            // Si no hay experiencias, devolvemos true (asumimos que ya pasó o no hay nada que mostrar)
            if (!experiences || experiences.length === 0) {
                return true;
            }

            const experience = experiences[0];
            const today = now.toISOString().split('T')[0]; // YYYY-MM-DD

            // Recorremos todos los calendarios y horarios
            for (const calendar of experience.calendars) {
                for (const schedule of calendar.schedules) {
                    const startTime = schedule.start_session; // formato HH:mm:ss

                    // Creamos un objeto fecha completo para comparar
                    const [hours, minutes, seconds] = startTime.split(':').map(Number);
                    const sessionDate = new Date(today);
                    sessionDate.setHours(hours, minutes, seconds, 0);

                    // Si alguno no ha pasado, retornamos false
                    if (sessionDate > now) {

                        return false;
                    }
                }
            }

            return true;
        },
        isBlockedTodayByHours(day, experiences) {
            const today = new Date();
            day.setHours(0, 0, 0, 0); // Normaliza a medianoche

            const isToday = day.toDateString() === today.toDateString();



            if (!isToday) return false;

            // por algún motivo el componente elimina la experiecia pera poder calcuar se deja cacheada
            const hasPassAllHours = (this.experiences || globalExperience)?.flatMap(experience => experience.calendars
                .flatMap(calendar => calendar.schedules.map(schedule => schedule.start_session)))
                .every(hora => {
                    // Crear un objeto Date solo con la hora
                    const [hours, minutes] = hora.split(':').map(Number);
                    const sessionTime = new Date(today);
                    sessionTime.setHours(hours, minutes, 0, 0); // Establecer la hora y los minutos

                    // Comparar solo la hora, ignorando la fecha
                    return today.getHours() > sessionTime.getHours() ||
                        (today.getHours() === sessionTime.getHours() && today.getMinutes() > sessionTime.getMinutes());
                });

            return hasPassAllHours;
        },
        hasDataFullfilled: function () {
            const checkout = this.getCheckout();
            return Boolean(checkout.mail) || Boolean(checkout.name) || Boolean(checkout.dni) || Boolean(checkout.phone);
        },
        getNextMonthRange: function (dateStr) {
            const [day, month, year] = dateStr.split('/').map(Number);

            // Calculamos el primer día del siguiente mes
            const firstDayNextMonth = new Date(year, month, 1); // month ya es 1-based en el string, Date usa 0-based
            const formattedFirst = `${firstDayNextMonth.getDate()}/${firstDayNextMonth.getMonth() + 1}/${firstDayNextMonth.getFullYear()}`;

            // Calculamos el último día del siguiente mes
            const lastDayNextMonth = new Date(year, month + 1, 0); // Día 0 del subsiguiente = último día del siguiente
            const formattedLast = `${lastDayNextMonth.getDate()}/${lastDayNextMonth.getMonth() + 1}/${lastDayNextMonth.getFullYear()}`;

            return { firstDayNextMonth: formattedFirst, lastDayNextMonth: formattedLast };
        }
    }
}
